import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { ArrowDirection } from "../../common/services/realtime/stimulus-types";
import { ArrowStimulusBox } from "./style";

export const ArrowStimulus = ({ direction }: { direction: ArrowDirection }) => (
    <ArrowStimulusBox $direction={direction}>
        {direction === ArrowDirection.LEFT
            ? <FaArrowLeft aria-label="Seta para a esquerda" />
            : <FaArrowRight aria-label="Seta para a direita" />}
    </ArrowStimulusBox>
);
